"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gemona-del-friuli": {
    "3f9fe08a": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "campagnola": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f58bf75": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "campo-lessi": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "494d5745": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "campo-taboga": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec16726c": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "gemona": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2f85dc8": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "godo": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "08a7a083": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "maniaglia": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6428a32f": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "ospedaletto": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94a76ab2": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "piovega": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e6f61316": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "stalis": [{
      "hkey": "f3625a63",
      "slug": "gemona-del-friuli",
      "name": "Gemona del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;